module.exports = __webpack_public_path__ + "static/img/slices1.29dda4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/slices1.png
// module id = qHjf
// module chunks = 1